module.exports = __webpack_public_path__ + "static/media/logo.47abc022.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 49
// module chunks = 0